import { FilesController } from "@/entities";
import { Panel, PanelHeader, PanelBody } from "@/shared";

interface Props {
  panelTitle: string;
  name: string;
  control: any;
  defaultValue: any;
  setValue: any;
  accept?: string;
}
export function AdminCommonFileFilesWrite({
  panelTitle,
  name,
  control,
  defaultValue,
  setValue,
  accept,
}: Props) {
  return (
    <Panel>
      <PanelHeader>{panelTitle}</PanelHeader>
      <PanelBody className="p-0">
        <FilesController
          name={name}
          control={control}
          defaultValue={defaultValue}
          setValue={setValue}
          accept={accept}
        />
      </PanelBody>
    </Panel>
  );
}
